import { useEffect, useMemo, useState } from "react";

import { promptInputVariables } from "../utils";

import { PromptVersion } from "@/types/apiGetters";

export const usePromptInitialInputs = (promptVersion?: PromptVersion) => {
  const inputVariables = useMemo(() => promptInputVariables(promptVersion), [promptVersion]);
  const [initialInputs, setInitialInputs] = useState<Record<string, string>>({});

  useEffect(() => {
    setInitialInputs(previous =>
      inputVariables.reduce<Record<string, string>>((next, variable) => {
        next[variable] = previous[variable] ?? "";
        return next;
      }, {}),
    );
  }, [inputVariables]);

  return { inputVariables, initialInputs, setInitialInputs };
};
